module.exports = __webpack_public_path__ + "static/google_calender-bed6fbb7c7c50431ccac0590f034f006.png";